module.exports = __webpack_public_path__ + "img/smw-library09.8426fab7.jpg";